<div class="container mx-auto shadow-md rounded-lg relative max-w-[90vw] xl:max-w-[70rem]">
  <img
    src="assets/images/logos/company_logo_icon.svg"
    alt="Add Codi Logo"
    class="max-w-full h-auto absolute pt-3 ps-2 rounded-lg"
  />
  <div class="grid lg:grid-cols-2 grid-cols-1 justify-center items-center loginBox">
    <div class="lg:py-3">
      <div class="md:p-[4rem] p-4">
        <div class="flex justify-center">
          <i
            class="pi pi-user-plus w-[42px] h-[42px] border border-neutral-200 rounded-[10px] !flex items-center justify-center bg-[linear-gradient(180deg,#FFFFFF_0%,#F1F1F1_115.48%)]"
          ></i>
        </div>
        <div class="pt-3 text-center">
          <span class="login-heading text-xl font-semibold text-neutral-900">{{
            'login.title' | translate
          }}</span>
          <span class="login-subheading text-sm text-neutral-500 block">{{
            'login.subheading' | translate
          }}</span>
        </div>
        <form [formGroup]="loginForm" class="flex flex-col gap-4 pt-4">
          <div class="flex flex-col">
            <label class="form-theme-label !text-xs" for="email">Email</label>
            <input
              pInputText
              id="email"
              aria-describedby="email-help"
              formControlName="email"
              pSize="small"
              [placeholder]="'login.email_placeholder' | translate"
            />
          </div>
          <div class="flex flex-col relative">
            <label class="form-theme-label !text-xs" for="password">{{
              'login.password' | translate
            }}</label>
            <input
              [type]="passwordInputType()"
              pInputText
              id="password"
              aria-describedby="password-help"
              formControlName="password"
              pSize="small"
            />
            <i
              (click)="onPasswordShow()"
              class="pi pi-{{
                eyeIcon()
              }} absolute right-[10px] top-[50%] translate-y-[3px] cursor-pointer"
            ></i>
          </div>
          <div>
            <div
              class="forgot-password !text-xs text-primary my-3 cursor-pointer font-medium inline-flex"
              routerLink="/auth/forgot-password"
            >
              {{ 'login.forgot_password' | translate }}
            </div>
            <p-button
              type="submit"
              class="w-100-button"
              [raised]="true"
              (click)="onLogin()"
              [disabled]="!loginForm.valid || (authService.isLoading$ | async)"
            >
              @if ((authService.isLoading$ | async) === false) {
                <span>{{ 'login.title' | translate }}</span>
              } @else {
                <span class="flex items-center justify-center gap-1">
                  <i class="pi pi-spin pi-spinner"></i>
                  <span class="leading-none">{{ 'login.logging_in' | translate }}</span>
                </span>
              }
            </p-button>
          </div>
        </form>
      </div>
      <div
        class="auth-footer lg:absolute lg:w-1/2 bottom-0 lg:left-0 flex justify-between items-center lg:pt-0 px-4 lg:pb-2 sticky w-full pb-0"
      >
        <span class="rights-reserved text-xs text-neutral-500">{{
          'auth.rights_reserved' | translate
        }}</span>
        <p-select
          [options]="translateService.langOption"
          size="large"
          (onChange)="switchLang($event.value.value)"
          [(ngModel)]="translateService.selectedLanguage"
          optionLabel="name"
          [dt]="authService.getDesignTokens()"
        >
          <ng-template #selectedItem let-selectedOption>
            <div class="flex items-center gap-2">
              <img
                [src]="translateService.selectedLanguage.image"
                class="w-[22px] h-[13px]"
                alt="Country Flag"
              />
              <div>{{ selectedOption.name }}</div>
            </div>
          </ng-template>
          <ng-template let-lang #item>
            <div class="flex items-center gap-2">
              <img [src]="lang.image" class="w-[22px] h-[13px]" alt="Country Flag" />
              <div>{{ lang.name }}</div>
            </div>
          </ng-template>
        </p-select>
      </div>
    </div>

    <div class="px-0 lg:block hidden">
      <img
        src="assets/images/backgrounds/login_frame.png"
        alt="Login Background"
        class="max-w-full h-auto rounded-lg"
      />
    </div>
  </div>
</div>
